import Api from "../apiService";

class chatProvidersApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/chat_providers`,
      params,
      Api.authHeaders()
    );
  }

  connectionConfig(companyId) {
    return Api.getRequest(
      `companies/${companyId}/chat_providers/connection_config`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/chat_providers`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, chatProviderId, data) {
    return Api.patchRequest(
      `companies/${companyId}/chat_providers/${chatProviderId}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, chatProviderId) {
    return Api.patchRequest(
      `companies/${companyId}/chat_providers/${chatProviderId}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, chatProviderId) {
    return Api.patchRequest(
      `companies/${companyId}/chat_providers/${chatProviderId}/disable`,
      {},
      Api.authHeaders()
    );
  }

  checkWebhook(companyId, chatProviderId) {
    return Api.postRequest(
      `companies/${companyId}/chat_providers/${chatProviderId}/check_webhook`,
      {},
      Api.authHeaders()
    );
  }
}

export default new chatProvidersApi();
